import React from 'react'
import cx from 'classnames'
import { RichTextMicroCopy } from 'pages/news/components/newsDetail/components/rich-text/RichText'
import RichTextType from 'models/types/ts/richTextType'
import style from './DonateButton.module.scss'

interface DonateButtonProps {
    onClick: () => void
    isDisabled: boolean
    loading: boolean
    buttonText: RichTextType
}

const DonateButton: React.FC<DonateButtonProps> = ({
    onClick,
    isDisabled,
    loading,
    buttonText,
}) => {
    return (
        <button
            type="button"
            className={cx(style.donateButton, {
                [style.loading]: loading,
            })}
            onClick={onClick}
            disabled={isDisabled || loading}
        >
            {loading ? (
                <span className={style.loader} />
            ) : (
                <RichTextMicroCopy document={buttonText} />
            )}
        </button>
    )
}

export default DonateButton
